<!-- sla-due-date-filters.component.html -->
@if (!isDisabled) {
    <div class="sla-due-date-filters-container">
        @for (card of slaFilterCards; track card.id) {
            <mat-card class="sla-due-date-filter-card"
                [class.selected]="card.selected"
                [class.sla-due-date-filter-card--past-due]="card.id === 'pastDue'"
                [class.sla-due-date-filter-card--due-today]="card.id === 'dueToday'"
                [class.sla-due-date-filter-card--due-tomorrow]="card.id === 'dueTomorrow'"
                [style.border-color]="card.selected ? 'var(--sla-card-color)' : 'transparent'"
                (click)="onCardSelectionChange(card)">
                <div class="filter-header">
                    <span class="filter-label">{{ card.label }}</span>
                    <mat-checkbox
                        [checked]="card.selected"
                        class="filter-checkbox">
                    </mat-checkbox>
                </div>
                <div class="filter-count-row">
                    <div class="filter-count-group">
                        <span class="filter-count">{{ card.count }}</span>
                        <span class="filter-count-total"> of {{ totalItems }}</span>
                        @if (card.id === 'dueTomorrow') {
                            <mat-icon class="filter-trend filter-trend--up">arrow_upward</mat-icon>
                        }
                    </div>
                    <span class="filter-status-label">{{ card.statusLabel }}</span>
                </div>
                <div class="filter-progress-bar">
                    <div class="filter-progress-fill" [style.width.%]="getPercentage(card.count)"></div>
                </div>
                <span class="filter-percentage">{{ getPercentage(card.count) }}% of total</span>
            </mat-card>
        }
    </div>
}
